import Service from 'react-reservice';

import { EForgotPasswordContent } from './types';

export interface IForgotPasswordServiceContext {
  loading: boolean;
  content: EForgotPasswordContent;
  email: string | undefined;
  metatraderId: string | undefined;
}

const defaultContext: IForgotPasswordServiceContext = {
  loading: false,
  content: EForgotPasswordContent.FORM,
  email: undefined,
  metatraderId: undefined
};

class ForgotPasswordService extends Service<IForgotPasswordServiceContext> {
  constructor() {
    super();

    this.context = { ...defaultContext };
  }

  setContent = (content: EForgotPasswordContent) => {
    this.context.content = content;
  };

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  setEmail = (email: string) => {
    this.context.email = email;
  };

  setMetatraderId = (id: string) => {
    this.context.metatraderId = id;
  };

  reset = () => {
    this.context = {
      ...defaultContext
    };
  };
}

export const forgotPasswordService = new ForgotPasswordService();
